import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CollegeRecrutingCenterService } from '../../../services/college-recruiting-center.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { HelperService } from '../../../services';

@Component({
  selector: 'app-top-four-boxes',
  templateUrl: './top-four-boxes.component.html',
  styleUrls: ['./top-four-boxes.component.css']
})


export class TopFourBoxesComponent implements OnInit {
  public playerID;
  public currentUrl;
  @Input() perData: any[];
  @Input() textData: any[];
  @Input() linkData: any[];
  @Input() toolTip: string;

  constructor(
    private service: CollegeRecrutingCenterService,
    private loader: Ng4LoadingSpinnerService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private helperService: HelperService,
  ) { }

  ngOnInit() {
    this.playerID = localStorage.getItem('playerID');
    if (this.router.url.replace('/recruiting-center', '').includes('/college-reports/')) {
      this.currentUrl = 'view';
    } else if (this.router.url.replace('/recruiting-center', '').includes('/college-attendance/')) {
      this.currentUrl = 'game';
    }
  }

  redirectTo(link) {
    if (link != null) {
      this.router.navigate([link]);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/top-four-boxes/top-four-boxes.component.ts